var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.71582,
    cy: 8,
    r: 8,
    fill: "#6D51F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82717 8.90118L10.4494 6.27896C10.5309 6.19748 10.6346 6.15674 10.7605 6.15674C10.8864 6.15674 10.9901 6.19748 11.0716 6.27896C11.1531 6.36044 11.1938 6.46415 11.1938 6.59007C11.1938 6.716 11.1531 6.8197 11.0716 6.90118L8.13828 9.83452C8.04939 9.92341 7.94569 9.96785 7.82717 9.96785C7.70865 9.96785 7.60495 9.92341 7.51606 9.83452L6.3605 8.67896C6.27902 8.59748 6.23828 8.49378 6.23828 8.36785C6.23828 8.24192 6.27902 8.13822 6.3605 8.05674C6.44198 7.97526 6.54569 7.93452 6.67161 7.93452C6.79754 7.93452 6.90124 7.97526 6.98273 8.05674L7.82717 8.90118Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.45e137c05436685146781a079fc5b370.svg";
export { ForwardRef as ReactComponent };